import { FLOWS } from './constants';

export const isSearchResultsFlow = (flow: string): boolean =>
    flow === FLOWS.SEARCH || flow === FLOWS.BUSINESS_SEARCH || flow === FLOWS.PROFESSION_CATEGORY;
